import { AuditListPayload } from 'src/types';

export function formatAuditListParams(
  params: AuditListPayload
): URLSearchParams {
  const urlParams = new URLSearchParams();

  if (params.auditable_type !== undefined && params.auditable_type !== null) {
    urlParams.set('auditable_type', String(params.auditable_type));
  }
  if (params.auditable_id !== undefined && params.auditable_id !== null) {
    urlParams.set('auditable_id', String(params.auditable_id));
  }
  if (params.event !== undefined && params.event !== null) {
    urlParams.set('event', String(params.event));
  }
  if (params.from_at !== undefined && params.from_at !== null) {
    urlParams.set('from_at', String(params.from_at));
  }
  if (params.to_at !== undefined && params.to_at !== null) {
    urlParams.set('to_at', String(params.to_at));
  }

  return urlParams;
}
